import type { ExtensionComponents } from '@atlassian/conversation-assistant-widget/common/utils/extension-components-context/types';

export const importOmniChannelExtensionComponents = (): Promise<ExtensionComponents> => {
	return import('@atlassian/conversation-assistant-widget/omni-channel-extension-components').then(
		({ OmniChannelExtensionComponents }) => {
			return OmniChannelExtensionComponents;
		},
	);
};
